var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview"},[_c('div',{staticClass:"overview__filters"},[_c('Filters')],1),_c('div',{staticClass:"overview__main"},[_c('Search'),_c('Results')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }